import Menu from ".";
import { useAuthContext } from "../../../context/AuthContext";

const EnhancementMenu = () => {
  const { business } = useAuthContext();
  return <Menu business={business} />;
};

export default EnhancementMenu;
